import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0d9488',
      light: '#14b8a6',
      dark: '#0f766e',
    },
    secondary: {
      main: '#134e4a',
      light: '#115e59',
      dark: '#042f2e',
    },
    background: {
      default: '#ecfdf5',
      paper: '#ffffff',
    },
    text: {
      primary: '#042f2e',
      secondary: '#115e59',
    },
    success: { main: '#059669' },
    warning: { main: '#d97706' },
    error: { main: '#dc2626' },
  },
  typography: {
    fontFamily: '"Outfit", system-ui, sans-serif',
    h4: { fontFamily: '"Source Serif 4", Georgia, serif', fontWeight: 700 },
    h5: { fontFamily: '"Source Serif 4", Georgia, serif', fontWeight: 700 },
    h6: { fontFamily: '"Source Serif 4", Georgia, serif', fontWeight: 700 },
  },
  shape: { borderRadius: 14 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid rgba(4, 47, 46, 0.06)',
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
